import { useEffect } from 'react'
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react'
import { useToastStore, type Toast as ToastT } from '../../stores/toastStore'
import styles from './Toast.module.css'

/**
 * Container globale dei toast — va montato UNA SOLA VOLTA in App.tsx.
 * Renderizza tutti i toast attivi nel DOM in bottom-right.
 */
export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts)
  if (toasts.length === 0) return null
  return (
    <div className={styles.container} aria-live="polite">
      {toasts.map((t) => (
        <ToastSingolo key={t.id} toast={t} />
      ))}
    </div>
  )
}

function ToastSingolo({ toast }: { toast: ToastT }) {
  const rimuovi = useToastStore((s) => s.rimuovi)

  useEffect(() => {
    if (toast.durataMs <= 0) return
    const id = setTimeout(() => rimuovi(toast.id), toast.durataMs)
    return () => clearTimeout(id)
  }, [toast, rimuovi])

  const Icona = toast.tipo === 'success' ? CheckCircle2
    : toast.tipo === 'errore' ? AlertCircle
    : Info

  return (
    <div className={`${styles.toast} ${styles[toast.tipo]}`} role="status">
      <Icona size={18} className={styles.icona} />
      <div className={styles.messaggio}>{toast.messaggio}</div>
      <button
        className={styles.chiudi}
        onClick={() => rimuovi(toast.id)}
        aria-label="Chiudi"
      >
        <X size={14} />
      </button>
    </div>
  )
}
